$(document).ready(function(){
	if(!document.querySelector('.email-common')) return false;
	
	/* LGEIS-11 20200402 add */
	var	_CONST = {
		countrycode: document.getElementsByTagName("html")[0].getAttribute("data-countrycode"),
		chkTypeOfInquiry: function(){
			var $sel = $('#typeOfInquiry');
			var result = false;
			
			if (!$sel.length) {
				return false;
			}
			
			switch (_CONST.countrycode) {
				case 'it':
					result = /^(1|2|3|4|5|8|13|14|23|24)$/.test(($sel.val() || '').replace(/^0+/,''));
					break;
	
				default:
					break;
			}
			
			return result;
		},
	};
	/*//LGEIS-11 20200402 add */
	// model search area setting
	var model = {
		// search area
		search: {
			el: document.getElementById('productSearchForm'),
			input: null,
			$anchorList: null,
			myProduct: document.getElementById('myProductList'),
			init: function(){
				var m = model.search;
				m.input = $(m.el).find('.search-common-input').get(0);
				m.$anchorList = $(m.el).find('ul.list');
			}
		},
		// select area
		select: {
			el: document.getElementById('productSelectForm'),
			cate: document.getElementById('categoryId'),
			subCate: document.getElementById('subCateId'),
			model: document.getElementById('modelNumber_sel'),
			init: function(){
				var m = model.select;

				$(m.cate).drawAjaxOptions({
					setTarget: m.subCate,
					empty: m.empty,
					notEmpty: m.notEmpty
				});
				$(m.subCate).drawAjaxOptions({
					setTarget: m.model
				});
			},
			empty: function(){
				var m = model.select;
				var _this = this;
				/*
				m.subCate.removeAttribute('disabled');
				$(m.subCate).append("<option value='"+xssfilter($(m.cate).val())+"' selected></option>")
					.addClass('hidden').trigger('change');
				*/
				//m.subCate.removeAttribute('disabled');
				//$(m.subCate).trigger('change').attr('disabled','disabled').trigger('chosen:updated');

				if(m.cate.selectedIndex != 0 && m.cate.value != '') {
					m.subCate.removeAttribute('disabled');
					$(m.subCate).append("<option value='"+xssfilter($(m.cate).val())+"' selected></option>")
						.addClass('hidden').trigger('change');
				}
			},
			notEmpty: function(){
				var m = model.select;
				$(m.subCate).removeClass('hidden');
			}
		},
		summary: document.getElementById('modelSummary'),
		init: function(){
			// search layer
			model.search.init();
			// select area
			model.select.init();

			model.addEvent();
		},
		pasteModelInfo: function(num, url, param){
			form.modelNum.value = num;
			var sum = model.summary;

			$('body').trigger('ajaxLoadBefore');
			ajax.call(url, param, 'json', function(data){
				$('body').trigger('ajaxLoadEnd');
				$(sum).find('img').get('0').src = data.imageUrl;
				var $anchor = $(sum).find('a');
				$anchor.get('0').href = data.link;
				if(data.link || data.link == '') {
					$anchor.addClass('disabled');
				}else {
					$anchor.removeClass('disabled');
				}
				
				$anchor.html(data.modelName);
				$(sum).find('.labo').html(data.warrantyInfoLabor);
				$(sum).find('.parts').html(data.warrantyInfoParts);
				bindImgError();

				// set visible model summary box
				$(sum).show().siblings().hide();
			});
		},
		addEvent: function(){
			model.search.$anchorList.on({
				click: function(e){
					e.preventDefault();
					var _this = e.currentTarget,
					val = _this.getAttribute('href'),
					param = model.search.el.getAttribute('data-param')+ "=" + val;
					model.search.input.value = val;
					$(model.search.el).find('.search-layer').removeClass('active'); // close search layer
					model.pasteModelInfo(val, model.search.el.action, param);

					$(_this).closest('.field-block').removeClass('error');
				}
			}, 'a');
			/* LGEITF-572 Start */
			if(!!$(model.search.el).length){ 
				$(model.search.myProduct).on({
					click: function(e){
						e.preventDefault();
						var _this = e.currentTarget,
						val = _this.getAttribute('href'),
						param = model.search.el.getAttribute('data-param')+ "=" + val;

						model.search.input.value = val;
						model.pasteModelInfo(val, model.search.el.action, param);
					}
				}, 'a');
			} 
			/* LGEITF-572 End */
			$(model.select.cate).on({
				'change.base': function(){
					$(model.select.model).find('option:not(:first-child)').remove();
					$(model.select.model).attr('disabled','disabled').trigger('chosen:updated');
				}
			});
			$(model.select.model).on({
				change: function(){
					var param = xssfilter($(model.select.el).serialize());
					var url = model.select.el.action;
					var val = $(model.select.model).val();
					model.pasteModelInfo(val, url, param);
				}
			});

			$(model.search.el).on({
				focus: function(e){
					$(e.delegateTarget).addClass('focused');
					$(model.select.el).removeClass('focused').find('.error').removeClass('error');
					$(model.select.el).find('select').removeAttr('required');
					$(model.search.input).attr('required','required');
				}
			}, 'input');
			$(model.select.el).on({
				focus: function(e){
					$(e.delegateTarget).addClass('focused');
					$(e.delegateTarget).find('select').attr('required','required');
					$(model.search.el).removeClass('focused').find('.error').removeClass('error');
					$(model.search.input).removeAttr('required');
				}
			}, 'select, input');
			$(model.summary.querySelector('.delete')).on({
				click: function(){
					$(model.summary).hide().siblings().show();
					document.getElementById('productSearchForm').reset();
					document.getElementById('productSelectForm').reset();
					document.getElementById('modelNumber_hidden').value = '';

					$('#subCateId').attr('disabled','disabled');
					$('#modelNumber_sel').attr('disabled','disabled');
					$('#productSelectForm select').trigger('chosen:updated');
				}
			});
		}
	};
	// form validation
	var form = {
		el: document.getElementById('emailSendingForm'),
		submitBtn: document.querySelector('.in-step-cluster button'),
		modelNum: document.getElementById('modelNumber_hidden'),
		typeSel: document.getElementById('typeOfInquiry'),
		typeNum: document.getElementById('typeOfInquiry_hidden'),
		file: document.querySelector('ul.file-delivery-pack li .replace-file-input input[type=file]'),
		// 20200325 START 구유정 || form.textarea selector 변경, form.tabArea 추가
		textarea: document.querySelectorAll('.intext-area textarea'),
		tabArea: document.querySelector(".tab-wrap"),
		// 20200325 END 구유정 || form.textarea selector 변경, form.tabArea 추가
		textarea: document.getElementById('aboutMessage'),
		// 200421 전호근 - form.typeSubject 추가
		typeSubject: document.getElementById('aboutSubject'),
		/* LGEIS-11 20200325 add */
		$searchKeyword: $('#search-keyword_1'),
		$superCategory: $('#superCategory_1'),
		radioSelect: document.getElementById('ceo-email-form-select'), // LGEUK-26  20200422 add
		/*//LGEIS-11 20200325 add */
		/* LGECO-123 Start */
		aboutAddress: document.querySelector('select[id=aboutAddress]'),
		aboutProvince: document.querySelector('select[id=aboutProvince]'),
		aboutState: document.querySelector('select[id=aboutState]'),
		infoInput : $(".email-cluster.about-you").find("input[type='text'],[type='email'],[type='tel'],[type='number']"), // LGECS-329
		/* LGECO-123 End */
		init: function(){			
			chosenScrollInit();
			
			// 20200325 START 구유정 || each textarea checkTextLength
			$(form.textarea).each(function(){
				checkTextLength($(this), $(this).siblings('.left-text').find('.count')); // textarea 글자수 체크
			})
			// 20200325 END 구유정 || each textarea checkTextLength

			form.addEvent();

			// 브라우저 back버튼 눌러서 돌아왔을 때 inquiry type 체크하여 데이터 있으면 초기화
			var firstValue=$('#typeOfInquiry').val();
			
			if(firstValue && firstValue != '') {
				//form.el.typeOfInquiry.value = firstValue;
				/* LGEMS-31 20210201 modify */
				var initValue = '';
				if(_CONST.countrycode === 'mx'){
					var mxValue = getUrlParams().typeOfInquiry;
					if(mxValue && mxValue == 'ACCYPUR') initValue = mxValue;
				}
				$('#typeOfInquiry').val(initValue).trigger('chosen:updated');
				/* //LGEMS-31 20210201 modify */
			}
			
			$(form.el).find("#file").length && $(form.el).find("#file").fileUploadSet();

			// input aboutSubject value = query string parameter in "receiptNumber"
			var queryStringObj = form.setQueryStringObj();
			if(queryStringObj.hasOwnProperty("receiptNumber") && queryStringObj.receiptNumber){
				$(form.el).find(".about-your-inquiry").find("#aboutSubject, #aboutMessage").val(queryStringObj.receiptNumber);
			}

			// LGEUK-26  20200422 add
			if ( form.radioSelect && form.el ) form.radioEvent();
			/*LGEIN-453*/
			if(_CONST.countrycode === 'in' && typeof $("#aboutStateList").val() !== 'undefined'){
				var statename=$("#aboutStateList").val();
				var statenameArr = statename.split(",");
				var stateList="";
				$.each(statenameArr, function( index, value ) {                  
					stateList=stateList+"<option value='"+value+"'>"+value+"</option>";
				});
				$("#aboutState").append(stateList);
				$("#aboutState").trigger('chosen:updated');
			}
			/*LGEIN-453*/
			
			/* LGECO-123 Start */
			$(form.aboutAddress).drawAjaxOptions({
				setTarget: form.aboutProvince,
				callback: function(data) {
					$(form.aboutState).find('option:not(:first-child)').remove();
					$(form.aboutState).find('option:first-child').prop('selected', true);
					$(form.aboutState).trigger('chosen:updated');
				}
			});
			$(form.aboutProvince).drawAjaxOptions({
				setTarget: form.aboutState
			});
			/* LGECO-123 End */
			// LGECS-329 start
			for( var i=0; i<form.infoInput.length; i++){
				$(form.infoInput[i]).data("orgvalue",form.infoInput[i].value);
			}
			// LGECS-329 end
		},
		/* LGEUK-26  20200422 add */
		radioEvent : function(){
			var $radio = $(form.radioSelect).find('button');
			$radio.on('click', function(){
				var $this = $(this);
				setActiveChange($this);
			});
			$radio.on('keydown', function (e) {
				if ((e.which === 39 || e.which === 40)) {
					e.preventDefault();
					var $this = $(this);
					if ( $this.is(':last-child') ){
						$this = $this.parent().find('button:first');
					} else {
						$this = $this.next();
					}
					setActiveChange($this);
					$this.focus();
				}
				if ((e.which === 37 || e.which === 38)) {
					e.preventDefault();
					var $this = $(this);
					if ( $this.is(':first-child') ){
						$this = $this.parent().find('button:last');
					} else {
						$this = $this.prev();
					}
					setActiveChange($this);
					$this.focus();
				}
			});
			function setActiveChange($this){
				$this.addClass('btn-active').attr({ 'aria-checked': true, 'tabindex' : "0" })
					.siblings('button').removeClass('btn-active').attr({ 'aria-checked': false, 'tabindex' : "-1" });
				$(".sub-select").find('select').prop('disabled', false).trigger('chosen:updated');
				//$(form.el).removeClass('d-none');
				// $(form.el).removeClass('d-none').find('input, textarea').val('').prop('checked', false)
				// 	.end().find('.delivery-part .delete').trigger('click');
				// var $fileInput = $(form.el).find('.delivery-part');
				// if( $fileInput.is('.attached') ) {
				// 	$fileInput.find('.delete').trigger('click');
				// }
			}
		},
		/* // LGEUK-26  20200422 add */
		setQueryStringObj: function(){
			var queryStringStr = location.search.length ? location.search.split("?")[1] : "";
			var queryStringObj = queryStringStr.split("&").reduce(function(prev, curr, i, arr) {
				if(curr != ""){
					var item = curr.split("=");
					prev[decodeURIComponent(item[0])] = ( item[1] ? decodeURIComponent(item[1]) : null );
					return prev;
				}
			}, {}) || {};
			return queryStringObj;
		},
		beforeSubmit: function(e){
			e.preventDefault();
			
			
			// whole form validation;
			if (!form.el.typeOfInquiry.value || form.el.typeOfInquiry.value == '') {
				window.scrollTo(0, $('.step-in-form').offset().top);
			}
			
			/* LGEIS-11 2020401 add */
			if (_CONST.countrycode === 'it' && _CONST.chkTypeOfInquiry() ) {
				if ($.trim(form.$searchKeyword.val())) {
					form.toggleRequired(form.$searchKeyword,true);
					form.toggleRequired(form.$superCategory,false);
				}
			}
			
			var formValidateResult = (_CONST.countrycode === 'it' || _CONST.countrycode === 'ca_en' || _CONST.countrycode === 'ca_fr') //LGECI-460
				? ( $(form.typeSel).checkValidation({trigger:true}) && $('.search-common').checkValidation() && $('.comboboxForm').checkValidation({trigger:true}) && $(form.el).checkValidation({trigger:true}) )
				: $(form.el).checkValidation({trigger:true});
				
				// LGECS-216 start
				var ceoQuestionSubType = $("#ceoQuestionSubType");
				var actionType = (ceoQuestionSubType != null && ceoQuestionSubType.length > 0) ? 'emailToCeo' : 'email';
				if( formValidateResult && ceoQuestionSubType != null && ceoQuestionSubType.length > 0){
					formValidateResult = $(ceoQuestionSubType).checkValidation({trigger:true});
					if( formValidateResult){
						$(ceoQuestionSubType).parents('.sub-select').removeClass('error');
					}else{
						$(ceoQuestionSubType).parents('.sub-select').addClass('error');
						$(ceoQuestionSubType).trigger('chosen:activate');
					}
				}
				// LGECS-216 end
			/*//LGEIS-11 2020401 add */
				if(formValidateResult) {
					// LGECS-329 start
					var chkOrgVal = 0;
					if( !$("#emailAccountCheck").prop("checked") && $("#LoginYn").val() == "Y"){
						for( var i=0; i<form.infoInput.length; i++){
							if( form.infoInput[i].value != $(form.infoInput[i]).data("orgvalue")){
								chkOrgVal++;
								break;
							}
						}
					}
					
					/* LGEMS-10 : 20200506 modify */
					// LGECI-541 start
					if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined ){
						/* LGEITF-310 : 20210412 add */
						if( !!$('#siteKey').val() && $("#useNewCaptchaView").val() == "N"){
							var reCaptcha_Key = $('#siteKey').val();
							// LGEGMC-5323 start
				        	grecaptcha.enterprise.ready(function() {
				        		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
				        			$("#verifyKey").val(btoa(token));
				        			if( chkOrgVal > 0){
										$('#mail_modify_confirm').modal('show');
									}else{
										form.formSubmit();
									}
				        		});
				        	});
				        	// LGEGMC-5323 end
						}else if( !!$('#verifyKey').val() && $("#useNewCaptchaView").val() == "Y"){
							if( chkOrgVal > 0){
								$('#mail_modify_confirm').modal('show');
							}else{
								form.formSubmit();
							}
						}else{
						/*// LGEITF-310 : 20210412 add */
							if( chkOrgVal > 0){
								$('#mail_modify_confirm').modal('show');
							}else{
								form.formSubmit();
							}
						}
					}else{
						if(captcha.validation() != false) {
							if( chkOrgVal > 0){
								$('#mail_modify_confirm').modal('show');
							}else{
								form.formSubmit();
							}
						}else {
							e.preventDefault();
						}
					}
					/*// LGEMS-10 : 20200506 modify */
					// LGECI-541 end
					// LGECS-329 end
				}
		},
		/* LGEMS-10 : 20200506 add */
		formSubmit: function(e){
			// 2019-07-13 submit 대신 ajax 방식으로 변경
			var url = $(form.el).attr('data-action');
			if(!url) {
				form.el.submit();
			} else {
				var params = new FormData();
				var curParams = $(form.el).serializeArray();

				for (var i = 0; i < curParams.length; i++) {
					fieldValue = form.el[curParams[i].name].value;

					if(form.el[curParams[i].name].length > 0) {
						var options = form.el[curParams[i].name];
							fieldValue = [];
						if(options.type !== undefined) {
							if(options.type.indexOf('select') >= 0) {
								fieldValue = options.options[options.selectedIndex].value;
								// console.log(fieldValue);
							}
						}else {
							for (var optionIdx = 0; optionIdx < options.length; optionIdx++) {
								var currentOpt = options[optionIdx];
								if(currentOpt.checked == true) {
									fieldValue += currentOpt.value;
								}
							}
						}
						
					}
					params.append(curParams[i].name, fieldValue);
				}

				//var params = new FormData($(form.el)[0]);
				$files = $(form.el).find('input:file');
				if($files.length > 0) {
					for (var j = 0; j < $files.length; j++) {
							var _file = $files.eq(j).get(0);
							if(_file.files[0]) {
								// console.log(_file.name, _file.files[0]);
								params.append(_file.name, _file.files[0], _file.files[0].name);
							}
						}
				}
				/* LGEITF-310 : 20210412 add */
				if(!!$('#verifyKey').val()){
					params.append('verifyKey', $('#verifyKey').val());
				}
				/*// LGEITF-310 : 20210412 add */
				
				params.append('recaptchaPageType', $('#recaptchaPageType').val());//LGEGMC-5375
				
				//console.log(params);
				var action = $(form.el).attr('action');

				$(form.submitBtn).attr("disabled", "disabled");

				ajax.noCacheCall(url, params, 'json', function(data){
					//$('body').append('<div style="width:100%;padding:30px;">'+JSON.stringify(data)+'</div>');
					// 20200525 START 구유정 || data.result true 조건 추가 (REDMINE #7538)
					if(data.result == false || data.result !== true){
						var $error = $('#step_submit_error');
						if(data.errorMessage && data.errorMessage != '') {
							$error.find('.content-paragraph').text(data.errorMessage);
						}else {
							$error.find('.content-paragraph').text($error.attr('data-default-msg'));
						}
						$error.modal('show');
						$(form.submitBtn).removeAttr("disabled");
						
						// LGECI-541 start
						if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined ){
							if( !!$('#verifyKey').val() && $("#useNewCaptchaView").val() == "Y"){
								reload_recaptcha_wrapper();
							}
						}
						// LGECI-541 end
					} else {
						var submitData = JSON.stringify(data.submitData);
						var tempForm = '<form id="tempEmailForm" action="'+action+'" method="'+commonSendType+'"><input type="hidden" name="data" value=""></form>';
						$('body').append(tempForm);
						var tmpform = document.getElementById('tempEmailForm');
						tmpform.data.value = submitData;
						tmpform.submit();
					}
					// 20200525 END 구유정 || data.result true 조건 추가 (REDMINE #7538)
				}, commonSendType, 'body');
			}
		},			
		/*// LGEMS-10 : 20200506 add */
		/* LGEIS-11 20200325 add */
		toggleRequired: function($target, bFlag) {
			$target.each(function(){
				var $this = $(this);
				var $label = $('label[for="'+$this[0].id+'"]').find(".require");
				if (bFlag) {
					$this.attr('required','required');
					$label.show();
				} else {
					$this.removeAttr('required');
					$label.hide();
				}
			});
		},
		/* //LGEIS-11 20200325 add */
		addEvent: function(){
			// typeSel selectbox event
			$(form.typeSel).on({
				change: function(){
					var $this = $(this);
					form.typeNum.value = $this.val();
					$this.parent().removeClass('error');
					
					/* LGEIS-11 20200325 add */
					if (_CONST.countrycode === 'it') {
						form.toggleRequired(form.$searchKeyword.add(form.$superCategory) ,_CONST.chkTypeOfInquiry());
					}
					/* //LGEIS-11 20200325 add */

					// 200421 START 전호근 - CN  type of Inquiry - VIP
					if (_CONST.countrycode === 'cn') {
						if (form.typeNum.value == '018') {
							$(form.typeSubject).val($(form.typeSubject).data('message').replace(/<br>/g, '\n')).prop('readonly', true);
							$(form.textarea).val($(form.textarea).data('message').replace(/<br>/g, '\n'));
						} else if ($(form.typeSubject).prop('readonly')) {
							$(form.typeSubject).val('').prop('readonly', false);
							$(form.textarea).val('');
						}
					}
					// 200421 END 전호근 - CN  type of Inquiry - VIP
				}
			});
			
			/* LGEIS-11 20200325 add */
			_CONST.countrycode === 'it' && form.$superCategory.on('invalid.required',function(){
				$(this).trigger('chosen:activate');
			});
			/* //LGEIS-11 20200325 add */
			
			// typeOfInquiry is not valid;
			$(form.typeNum).off().on({
				'invalid.required': function(){
					$(form.typeSel).parents('.field-block').addClass('error');
					$(form.typeSel).trigger('chosen:activate');
				},
				'valid.required': function(){
					$(form.typeNum).parents('.field-block').removeClass('error');
				}
			});
			// checkbox 체크 시, input readonly 추가
			$(form.el).on({
				change: function(e){
					var _this = e.target,
						$target = $(_this.getAttribute("data-same-as-id"));

					!$target.data("isRequired") && $target.data("isRequired", $target.prop("required")); // 처음 한번만 실행

					if(_this.checked){
						$target.removeAttr("required");
						$target.val("").attr("readonly","readonly");
					}else{
						$target.data("isRequired") && $target.attr("required", "required");
						$target.removeAttr("readonly");
					}
				}
			}, '.same-as-input');

			$(form.el).on({
				submit: form.beforeSubmit
			});
			
			/* LGECN-214 Start */
			$(form.el).find('button.btn-hmt').on('click', function(){
				if (_CONST.countrycode === 'cn' && typeof _hmt != 'undefined'){
					if(!!$('.model-view-image:visible').length){
						var target = $('.model-view-image').find('.product-info').find('.model-link');
						var product_name = target.attr('data-userfriendlyname') ? target.attr('data-userfriendlyname') : '';
						var product_sku = target.text();
						var product_category = target.attr('data-siblingcode') ? target.attr('data-siblingcode') : '';
						
						var cggroupName = 'support_email';
						var list_name = typeof baidu_lg_cggroup != 'undefined' ? (baidu_lg_cggroup[cggroupName] ? baidu_lg_cggroup[cggroupName] : cggroupName) : cggroupName;
						
						console.log('[Baidu trackEvent] [email_us_submit] ', ', list_name : '+ list_name, ', product_name : '+product_name, ', product_sku : '+product_sku, ', product_category : '+product_category);
						
						_hmt.push(['_trackCustomEvent', 'submit', {
						    'list_name': list_name,
						    'event_action': 'email_us_submit',
						    'product_name': product_name,
						    'product_sku': product_sku,
						    'product_category': product_category
						}]);
					}
				}
			})
			/* LGECN-214 End */

			// 20200325 START 구유정 || tab area js 추가
			$(form.tabArea).on("click", ".btn-tab", function(){
				var activeTarget = $(this).attr("data-active-target");
				var inactiveTarget = $(this).attr("data-inactive-target");
				
				$(activeTarget).show();
				$(inactiveTarget).hide();

				// 20200326 START 구유정 || hidden input required 추가
				if($(activeTarget).find(form.typeSel).length){
					$(form.typeNum).attr("required","required");
				}else{
					$(form.typeNum).removeAttr("required");
				}
				// 20200326 END 구유정 || hidden input required 추가
				
			})
			// 20200325 END 구유정 || tab area js 추가
			// LGECS-329 start
			$('#mail_modify_confirm').on({
				click: function(e){
					e.preventDefault();
					$("#emailAccountCheck").prop("checked",true);
					$("#mail_modify_confirm").modal('hide');
					form.formSubmit();
				}
			}, 'button[type="submit"]');
			
			$('#mail_modify_confirm').on({
				click: function(e){
					e.preventDefault();
					$("#emailAccountCheck").prop("checked",false);
					$('#mail_modify_confirm').modal('hide');
					form.formSubmit();
				}
			}, 'button[type="button"]');
			// LGECS-329 end
		}
	};
	// LGEUK-26 20200422 add
	if (model.summary){
		model.init();
	}
	form.init();
});